export default __webpack_public_path__ + "static/media/close.dd346210.svg";